import { withCompInfo } from '../../core/withCompInfo'
import {
	TimePickerDefinition,
	TimePickerProps,
	TimePickerCSSVars,
	TimePickerCssCarmiData,
	TimePickerAlignment,
} from './types'
import { getInputHeightInPx } from '../../core/inputUtils'

export const props = withCompInfo<TimePickerProps, TimePickerDefinition>(
	['compData', 'compProps'],
	({ compData, compProps }) => {
		const { value, placeholder, step, label } = compData
		const { useAmPmFormat, controller, initialTime, readOnly, isDisabled, required } = compProps

		return {
			value,
			placeholder: initialTime === 'none' ? '' : placeholder,
			step,
			label,
			useAmPmFormat,
			controller,
			initialTime,
			readOnly,
			isDisabled,
			required,
		}
	}
)

const alignmentCssVars = (alignment: TimePickerAlignment, labelPadding: number) => {
	return {
		'--textAlign': alignment,
		...(alignment === 'right'
			? {
					'--dir': 'rtl' as 'rtl',
					'--arrowMargin': '0 0 0 20px',
					'--flexDirection': 'row-reverse',
			  }
			: {
					'--dir': 'ltr' as 'ltr',
					'--arrowMargin': '0 20px 0 0',
					'--flexDirection': 'row',
			  }),
		...(alignment === 'right'
			? {
					'--labelPadding': `0 ${labelPadding}px 0 0`,
			  }
			: alignment === 'center'
			? {
					'--labelPadding': '0',
			  }
			: {
					'--labelPadding': `0 0 0 ${labelPadding}px`,
			  }),
	}
}

const inputPaddingVar = (alignment: TimePickerAlignment, isMobileView: boolean, margin: number = 15) => {
	return isMobileView
		? `0 ${margin}px`
		: alignment === 'left'
		? `0 0 0 ${margin}px`
		: alignment === 'right'
		? `0 ${margin}px 0 0`
		: '0'
}

export const css = withCompInfo<TimePickerCSSVars, TimePickerDefinition, TimePickerCssCarmiData>(
	['compLayout', 'compProps', 'compData', 'isMobileView'],
	({ compLayout, compProps, compData, isMobileView }, cssVars) => {
		const { label } = compData
		const { labelMargin, labelPadding, alignment, margin } = compProps

		return {
			...cssVars,
			...alignmentCssVars(alignment, labelPadding),
			'--labelMarginBottom': !label ? '0' : `${labelMargin}px`,
			'--inputPadding': inputPaddingVar(alignment, isMobileView, margin),
			'--inputHeight': getInputHeightInPx({ compProps, compLayout, isMobileView }),
			...(label ? { height: 'auto' } : {}),
		}
	}
)
